import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput } from '@angular/material/input';
import { MatHint } from '@angular/material/form-field';
import { CustomFieldTypePipe } from '../../../pipes/custom-field-type.pipe';

@Component({
  selector: 'app-custom-field-text',
  standalone: true,
  templateUrl: './custom-field-text.component.html',
  imports: [MatInput, MatFormField, ReactiveFormsModule, MatHint, CustomFieldTypePipe],
  styleUrl: './custom-field-text.component.scss'
})
export class CustomFieldTextComponent {
  @Input() group: FormGroup | null = null;
  @Input() showHint = false;
}
